import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { NAV_LINKS } from "../data";
import { IconMenu, IconClose } from "./icons";
import butterflyLogo from "../assets/images/logo/butterfly-logo.svg";

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  // Close mobile menu on route change
  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  const close = () => setMenuOpen(false);

  const navStyle = {
    position: "fixed", top: 0, left: 0, right: 0, height: "var(--nav-h)", zIndex: 1000,
    display: "flex", alignItems: "center", justifyContent: "center",
    background: "rgba(26,15,28,0.98)",
    backdropFilter: "blur(16px)", WebkitBackdropFilter: "blur(16px)",
    borderBottom: "1px solid rgba(212,168,83,0.15)",
  };

  return (
    <>
      <nav style={navStyle}>
        <div className="sb-container" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          {/* Logo */}
          <div
            onClick={() => { navigate("/"); window.scrollTo({ top: 0 }); }}
            style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "10px" }}
          >
            <span style={{
              fontFamily: "var(--font-display)", fontWeight: 700, fontSize: "1.25rem",
              color: "var(--gold)", letterSpacing: "0.02em",
            }}>
              Silly Butterfly
            </span>
            <img
              src={butterflyLogo}
              alt="Silly Butterfly logo"
              style={{ width: "2rem", height: "2rem", filter: "drop-shadow(0 0 8px rgba(212,168,83,0.3))", objectFit: "contain" }}
            />
          </div>

          {/* Desktop nav links — hidden on mobile via CSS */}
          <div className="sb-nav-links" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {NAV_LINKS.map(({ label, path }) => {
              const active = location.pathname === path;
              return (
                <button
                  key={path}
                  onClick={() => { navigate(path); window.scrollTo({ top: 0 }); }}
                  style={{
                    background: active ? "rgba(212,168,83,0.12)" : "none",
                    border: "none", cursor: "pointer",
                    fontFamily: "var(--font-body)", fontWeight: 500, fontSize: "0.9rem",
                    color: active ? "var(--gold)" : "rgba(255,255,255,0.7)",
                    padding: "8px 16px", borderRadius: "99px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => { if (!active) e.target.style.color = "var(--gold)"; }}
                  onMouseLeave={(e) => { if (!active) e.target.style.color = "rgba(255,255,255,0.7)"; }}
                >
                  {label}
                </button>
              );
            })}
            <button
              className="sb-btn sb-btn-primary"
              onClick={() => { navigate("/quote"); window.scrollTo({ top: 0 }); }}
              style={{ marginLeft: "12px", padding: "10px 24px", fontSize: "0.85rem" }}
            >
              Get a Quote
            </button>
          </div>

          {/* Mobile hamburger toggle */}
          <button
            className="sb-mobile-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
            style={{
              display: "none", background: "none", border: "none",
              color: "var(--gold)", cursor: "pointer", padding: "4px",
            }}
          >
            {menuOpen ? <IconClose /> : <IconMenu />}
          </button>
        </div>
      </nav>

      {/* Mobile overlay — sibling to <nav>, not a child, so backdrop-filter
          stacking context on the nav does not trap or clip this element */}
      {menuOpen && (
        <div
          style={{
            position: "fixed", top: "var(--nav-h)", left: 0, right: 0, bottom: 0,
            background: "var(--plum)", zIndex: 999,
            display: "flex", flexDirection: "column",
            alignItems: "center", justifyContent: "center",
            gap: "8px", padding: "32px 24px",
          }}
        >
          {NAV_LINKS.map(({ label, path }) => {
            const active = location.pathname === path;
            return (
              <button
                key={path}
                onClick={() => { navigate(path); window.scrollTo({ top: 0 }); close(); }}
                style={{
                  background: active ? "rgba(212,168,83,0.12)" : "none",
                  border: "none", cursor: "pointer",
                  fontFamily: "var(--font-body)", fontWeight: 500, fontSize: "1.2rem",
                  color: active ? "var(--gold)" : "rgba(255,255,255,0.75)",
                  padding: "12px 32px", borderRadius: "99px",
                  transition: "color 0.2s ease, background 0.2s ease",
                  width: "100%", maxWidth: "320px", textAlign: "center",
                }}
              >
                {label}
              </button>
            );
          })}
          <button
            className="sb-btn sb-btn-primary"
            onClick={() => { navigate("/quote"); window.scrollTo({ top: 0 }); close(); }}
            style={{ marginTop: "16px", padding: "14px 40px", fontSize: "1rem" }}
          >
            Get a Quote
          </button>
        </div>
      )}
    </>
  );
}
